/*
 * @Author: caiqin.xie
 * @since: 2023-07-26 19:01:25
 * @lastTime: 2024-01-02 15:15:52
 * @LastEditors: caiqin.xie
 * @message: 新闻详情
 * @url: www.picoxr.com/cn/newsroom/:seoUrl
 */
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Header from "@/components/Header/index";
import Footer from "@/components/Footer/index";
import HotTopic from "../components/HotTopic";
import ArticleTitle from "./components/ArticleTitle";
import RelatedArticles from "./components/RelatedArticles";
import request from '@/common/request'
import { useDevice } from '@/hooks'
import { DOMAIN_API, COUNTRY_HREFLANG, NEWSTYPE } from '@/common/const'
import { getUrlData } from '@/common/untils'
import styles from "./index.module.scss";
import { INews, IContentDetail } from "@/common/types";
import classNames from "classnames";
const _ = require("lodash");

const NewsroomDetail = (props: any) => {
  const {ctry, words, data} = props.data
  const device = useDevice()
  const [newsDetail, setNewsDetail] = useState<IContentDetail>(data?.content || null) // 新闻详情
  const [relatedList, setRelatedList] = useState<INews[]>(data?.contentPage?.records || []) // 最新新闻

  // 渲染HTML
  function creatHtml () {
    return {__html: newsDetail?.detail}
  }

  // 生成hreflang
  const renderHrefLang = () => {
    return (
      newsDetail && newsDetail.stationCodes && newsDetail.stationCodes.map(item => (
        <link key={item} rel="alternate" hrefLang={COUNTRY_HREFLANG[item]} href={`${DOMAIN_API}/${item}/newsroom/${newsDetail?.seoUrl}`} />
      ))
    )
  }

  return (
    <div>
      <Helmet>
        <title>{newsDetail?.seoTitle}</title>
        <meta name="description" content={newsDetail?.seoDescription} />
        <meta name="keywords" content={newsDetail?.seoKeywords} />
        <link rel="canonical" href={newsDetail?.seoCanonical} />
        {renderHrefLang()}
        <script type="application/ld+json">
          {newsDetail?.structuredCode}
        </script>
      </Helmet>
      <Header ctry={ctry} words={words}/>
      <main className={styles['news-wrap']}>
        {/* 顶栏 */}
        <HotTopic ctry={ctry} words={words}></HotTopic>

        {/* 内容区 */}
        <div className={styles["content-wrap"]}>
          <section className={`${styles['section']} ${styles['section-article']}`}>
            {/* 新闻标题 */}
            <ArticleTitle ctry={ctry} words={words} newsDetail={newsDetail} />
            {/* 新闻内容 */}
            <article className={classNames(styles['article-content'], 'editor-wrap')} dangerouslySetInnerHTML={creatHtml()}></article>
          </section>
          {/* 最新新闻 */}
          <RelatedArticles ctry={ctry} words={words} relatedList={relatedList} device={device} />
        </div>

      </main>
      <Footer />
    </div>
  );
};

function getInit (ctry: string, pathName: string) {
  return new Promise((resolve, reject) => {
    const decodedUrl = decodeURIComponent(pathName);
    const seoUrl = decodedUrl.split('?')[0].split('/').pop();
    const query = getUrlData(decodedUrl)
    request.post(`${DOMAIN_API}/o/official/content/getNewsDetailGather`, {
      contentTypeId: NEWSTYPE,
      seoUrl: seoUrl,
      stationCode: ctry,
      page: query.page || 1,
      rows: 10
    })
    .then(res => {
      resolve(res.data)
    })
    .catch(err => {
      reject(err)
    })
  })
}

NewsroomDetail.getInitialProps = (ctry: string, pathName: string) => {
  return getInit(ctry, pathName)
};
export default NewsroomDetail;
